export default __webpack_public_path__ + "static/media/natation.e26dba43.svg";